import { Link } from "react-router-dom";

interface DisclaimerProps {
  compact?: boolean;
  dark?: boolean;
}

const Disclaimer = ({ compact, dark }: DisclaimerProps) => {
  if (compact) {
    return (
      <p className={dark ? "text-xs text-alt-wht/50" : "text-xs text-alt-blk/55"}>
        Dates and camping rules change. Confirm on the official page.{" "}
        <Link
          to="/about"
          className={dark ? "text-ray hover:text-sunset" : "text-turquoise hover:text-mars"}
        >
          About
        </Link>
      </p>
    );
  }

  return (
    <p className="leading-relaxed">
      Seasons are curated from organizer calendars and can shift. On-site camping
      is not a reservation, and nearby camping is not a legal determination.
      Always confirm dates, tickets, and overnight rules with the event and the
      land manager before you roll.
    </p>
  );
};

export default Disclaimer;
